import axios, { type AxiosResponse } from 'axios'

import { type RequestForPriceFormValues } from '@lib/form'
import { type Locale } from '@lib/language'

export interface RequestProductPricePayload {
  variantId: number
  values: RequestForPriceFormValues
}

export interface RequestProductPriceResponse {
  error?: string
}

/**
 * Calls request product price API page.
 */
export const requestProductPrice = async (
  locale: Locale,
  variantId: number,
  values: RequestForPriceFormValues
) => {
  const payload: RequestProductPricePayload = {
    variantId,
    values,
  }
  const response = await axios.post<
    RequestProductPriceResponse,
    AxiosResponse<RequestProductPriceResponse>,
    string
  >('/api/shopify/request-product-price', JSON.stringify(payload), {
    headers: {
      'Content-Type': 'application/json',
      'X-Locale': locale,
    },
  })

  if (response.data.error) {
    throw new Error(response.data.error)
  }
}
